export default __webpack_public_path__ + "CircularCustCapNum-BoldItalic.c6fa887e0c6c808c3cacce5d3190cc58.ttf";